import { Component } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: "odq-technical-difficulties-dialog",
    templateUrl: "./technical-difficulties-dialog.component.html",
    styleUrls: ["./technical-difficulties-dialog.component.scss"],
    standalone: false
})
export class TechnicalDifficultiesDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<TechnicalDifficultiesDialogComponent>,
    public translate: TranslateService
  ) {}

  onCloseDialog(): void {
    this.dialogRef.close(false);
  }
}
